import gql from 'graphql-tag';
import fragments from './fragments';

export const GET_GAMES_QUERY = gql`
  query GetGames {
    games {
      games {
        ...Game
      }
    }
  }
  ${fragments.game}
`;

export const SUBSCRIPTION_GAME_UDPATES = gql`
  subscription GameUpdates {
    gameUpdates {
      game {
        ...Game
      }
      removeGameId
    }
  }
  ${fragments.game}
`;
